import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';

//icon imports
import PaymentsIcon from '@mui/icons-material/Payments';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

//services imports
import useEmployeeService from 'services/useEmployeeService';
import useBM6FieldExpenses from 'services/useBM6FieldExpensesService';
import useBM6SalarySlabs from 'services/useBM6SalarySlabsService';

//project imports
//import BM6Card from './BM6Card';
import ROBM6SalarySheet from './ROBM6SalarySheet';
import useSalariesService from 'services/useSalariesService';

const ROBM6 = (props) => {
    const { selectedRole, selectedLocation, selectedMonth, selectedYear } = props;
    const theme = useTheme();
    const navigate = useNavigate();

    //states
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState();
    const [bm6SalarySlabDetails, setBM6SalarySlabDetails] = useState();
    const [bm6FiledExpensesDetails, setBM6FiledExpensesDetails] = useState();
    const [salaryReadOnly, setSalaryReadOnly] = useState();
    //services
    const { getEmployees } = useEmployeeService();
    const { getBM6SalarySlab } = useBM6SalarySlabs();
    const { getBM6FieldExpensesByBM6SalarySlabId } = useBM6FieldExpenses();
    const { getAllSalaries } = useSalariesService();
    //handlers
    const handleGetEmployees = () => {
        getEmployees('', selectedRole, selectedLocation, 0, 100000)
            .then((response) => {
                if (response.status == 200) {
                    setEmployees(response.data.users);
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleGetSalaryReadOnly = () => {
        getAllSalaries(selectedRole, selectedLocation, selectedMonth, selectedYear)
            .then((response) => {
                console.log('response', selectedRole, selectedLocation, selectedMonth, selectedYear);
                if (response.status == 200) {
                    setSalaryReadOnly(response.data.salaries);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleGetSalarySlabs = () => {
        getBM6SalarySlab()
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.bM6SalarySlabs.length > 0) {
                        setBM6SalarySlabDetails(response.data.bM6SalarySlabs[0]);
                    }
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetFieldExpenses = () => {
        getBM6FieldExpensesByBM6SalarySlabId(bm6SalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setBM6FiledExpensesDetails(response.data.bM6FieldExpences);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //use effects
    useEffect(() => {
        handleGetEmployees();
        handleGetSalarySlabs();
    }, [selectedRole, selectedLocation]);

    useEffect(() => {
        if (bm6SalarySlabDetails) {
            handleGetFieldExpenses();
        }
    }, [bm6SalarySlabDetails]);
    useEffect(() => {
        handleGetSalaryReadOnly();
    }, [selectedRole, selectedLocation, selectedMonth, selectedYear]);
    return (
        <Box>
            <Grid container spacing={2}>
                {employees ? (
                    <>
                        {/* {employees.map((employee, index) => {
                            return ( */}
                        <Grid item xs={12} md={12}>
                            <ROBM6SalarySheet
                                employee={employees}
                                bm6SalarySlabDetails={bm6SalarySlabDetails}
                                bm6FiledExpensesDetails={bm6FiledExpensesDetails}
                                salaryData={salaryReadOnly}
                                onRefresh={() => {
                                    handleGetSalarySlabs();
                                    handleGetFieldExpenses();
                                }}
                                location={selectedLocation}
                                month={selectedMonth}
                                year={selectedYear}
                            />
                        </Grid>
                        {/* );
                        })} */}
                    </>
                ) : null}
            </Grid>
        </Box>
    );
};

export default ROBM6;
